export default __webpack_public_path__ + "static/media/serg333.e36296df.png";